import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Index from "./pages/home/Index";
import Contact from "./pages/contact/Contact";
import Loading from "./components/Loading";
import About from "./pages/about/About";
import { useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { hideLoading, setPortfolioData, showLoading, ReloadFalse } from "./redux/rootSlice";
import AdminIndex from './adminPanel/AdminIndex';
import AdminLogin from './adminPanel/AdminLogin';
import Error from "./components/Error";

function App() {
  const dispatch = useDispatch();
  const { reload, loading, portfolioData } = useSelector((state) => state.root);

  const getPortfolio = async () => {
    try {
      dispatch(showLoading());
      const response = await axios.get("https://backendz182.up.railway.app/api/portfolio/get-Portfolio");
      dispatch(setPortfolioData(response.data));
      dispatch(hideLoading());
      dispatch(ReloadFalse());
    } catch (error) {
      console.error(error);
    }
  };

  const initializeDarkMode = () => {
    if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  useEffect(() => {
    if (!portfolioData || reload) {
      getPortfolio();
    }

    initializeDarkMode();
  }, [portfolioData, reload]);

  return (
    <Router>
      {loading ? <Loading /> : null}
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/admin" element={<AdminIndex />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  );
}

export default App;
